import * as React from "react";
import { Button, StyleProp, StyleSheet, ViewStyle } from "react-native";

import { View } from "../../components/Themed";
import useCreateMove from "../../hooks/moves/useCreateMove";
import useCreateStudentProgress from "../../hooks/studentProgress/useCreateStudentProgress";
import useUpdateStudentProgress from "../../hooks/studentProgress/useUpdateStudentProgress";
import { Video } from "../../types";

export interface VideoListItemProps {
  style?: StyleProp<ViewStyle>;
  video?: Video;
}

function VideoListItem({ style }: VideoListItemProps) {
  const { mutateAsync: createMove } = useCreateMove();
  const { mutateAsync: createStudentProgress } = useCreateStudentProgress();
  const { mutateAsync: updateStudentProgress } = useUpdateStudentProgress();

  return (
    <View style={style}>
      <Button
        title="Add Move"
        onPress={async () => {
          try {
            var move = await createMove({});
            var studentProgress = await createStudentProgress({});
            var studentProgressId = studentProgress.id;
            // await updateStudentProgress({
            //   id: studentProgressId,
            //   move: move.id,
            // });
          } catch (err) {
            // TODO
          }
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({});

export default VideoListItem;
